import { ReactAccordionItem } from '@/components/react/ui/ReactAccordionItem';
import { type ReactCta } from '@/components/react/ui/ReactCta';
import { type ImageMetadata } from 'astro';
import type { ComponentProps } from 'astro/types';
import { cx } from 'cva';
import type React from 'react';
import type { PropsWithChildren } from 'react';

export interface ReactAccordionItemType {
  heading: string;
  subheading?: string;
  copy?: string;
  cta?: ComponentProps<typeof ReactCta>;
  image?: ImageMetadata;
}

interface ReactAccordionProps {
  hasBorders?: boolean;
  variant?: 'fill' | 'line' | 'comparison';
  items?: ReactAccordionItemType[];
}

export const ReactAccordion: React.FC<
  PropsWithChildren<ReactAccordionProps>
> = ({ hasBorders, variant, items, children }) => {
  const border = hasBorders || variant === 'line' || variant === 'comparison';

  return (
    <div
      className={cx(
        'accordion border-blurb-border-subtle flex w-full flex-col',
        border ? 'border-b' : 'gap-2',
      )}
    >
      {items ?
        items.map((item, idx) => <ReactAccordionItem key={idx} {...item} />)
      : children}
    </div>
  );
};
